/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type Frequency = (typeof Frequency)[keyof typeof Frequency];

export const Frequency = {
    Weekly: 1,
    Monthly: 2,
    ThreeMonthly: 3,
    SixMonthly: 4,
    Annually: 5,
    ThreeYearly: 6,
    FiveYearly: 7,
    SixYearly: 8,
    TenYearly: 9,
    TwelveYearly: 10,
    TwentyFourYearly: 11,
    TwentyFiveYearly: 12,
    ThirtyYearly: 13,
} as const;
